import { render, staticRenderFns } from "./EvaluationColumnBoolean.vue?vue&type=template&id=014a8b40&scoped=true&"
import script from "./EvaluationColumnBoolean.vue?vue&type=script&lang=js&"
export * from "./EvaluationColumnBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a8b40",
  null
  
)

export default component.exports